import { render, staticRenderFns } from "./customer-performance.vue?vue&type=template&id=ef060422&scoped=true&"
import script from "./customer-performance.vue?vue&type=script&lang=js&"
export * from "./customer-performance.vue?vue&type=script&lang=js&"
import style0 from "./customer-performance.vue?vue&type=style&index=0&id=ef060422&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef060422",
  null
  
)

export default component.exports